import styled from "styled-components";
import { Avatar } from "../Avatar/Avatar.styled";

export const Image = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
`;

export const Text = styled.p`
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => (props.placeholder ? "#667085" : "#101828")};

  span {
    color: #bfbfc4;
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    margin-left: 4px;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;

  > ${Avatar}, > svg {
    flex: 0 0 auto;
  }

  > ${Text} {
    flex: 1 0 auto;
    margin-left: 12px;
  }
`;
